import { ChangeEvent, FC, ReactNode, useCallback, useState } from 'react';
import { FieldArray, useField } from 'formik';

import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import TableContainer, {
  TableContainerProps,
} from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import MuiTextField from '@mui/material/TextField';
import TableCell from 'components/TableCell';
import TextField from 'components/TextField';
import Typography from '@mui/material/Typography';
import ConfirmableIconButton from 'components/ConfirmableIconButton';
import IconButton from '@mui/material/IconButton';

export type KeyValuePair = TableContainerProps & {
  key: string;
  value: string;
};

type Props = {
  name: string;
  label?: ReactNode;
};

const KeyValueArrayField: FC<Props> = ({ name, label, ...props }) => {
  const [field] = useField<KeyValuePair[]>(name);
  const [keyToAdd, setKeyToAdd] = useState('');
  const [valueToAdd, setValueToAdd] = useState('');

  const handleKeyToAddChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setKeyToAdd(event.target.value);
    },
    []
  );

  const handleValueToAddChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setValueToAdd(event.target.value);
    },
    []
  );

  return (
    <TableContainer {...props}>
      {label && <Typography variant="caption">{label}</Typography>}

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Parametras</TableCell>
            <TableCell>Reikšmė</TableCell>
            <TableCell sx={{ width: '10px' }} />
          </TableRow>
        </TableHead>

        <TableBody>
          <FieldArray name={name}>
            {({ remove, push }) => (
              <>
                {field.value.map((_, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <TextField fullWidth name={`${name}.${i}.key`} />
                    </TableCell>

                    <TableCell>
                      <TextField fullWidth name={`${name}.${i}.value`} />
                    </TableCell>

                    <TableCell>
                      <ConfirmableIconButton onConfirm={() => remove(i)}>
                        <DeleteIcon fontSize="small" />
                      </ConfirmableIconButton>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell>
                    <MuiTextField
                      fullWidth
                      variant="standard"
                      value={keyToAdd}
                      onChange={handleKeyToAddChange}
                    />
                  </TableCell>

                  <TableCell>
                    <MuiTextField
                      fullWidth
                      variant="standard"
                      value={valueToAdd}
                      onChange={handleValueToAddChange}
                    />
                  </TableCell>

                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => {
                        push({
                          key: keyToAdd,
                          value: valueToAdd,
                        });

                        setKeyToAdd('');
                        setValueToAdd('');
                      }}>
                      <AddIcon color="success" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </>
            )}
          </FieldArray>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default KeyValueArrayField;
